<template>
  <div class="wrapper">
    <div class="searchBar">
      <div>
        <el-input
          placeholder="搜索学院姓名、证书名称、身份证号"
          v-model="searchCondition.search"
          size="small"
          style="width: 160px"
        ></el-input>
      </div>
      <div>
        <el-date-picker
          type="date"
          placeholder="上传登记时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          size="small"
          v-model="searchCondition.createTime"
        >
        </el-date-picker>
        &ensp;&ensp;&ensp;&ensp;
        <el-button type="primary" size="small" @click="getData">查询</el-button>
      </div>
    </div>
    <div class="content">
      <div class="actBar">
        <el-button size="small">导出</el-button>
        <el-button size="small">导入</el-button
        ><el-button size="small">下载模板</el-button>
      </div>
      <div class="tableContainer">
        <el-table
          :data="dataList"
          border
          style="width: 100%"
          :cell-style="{ padding: '8px 0', fontSize: '14px' }"
        >
          <el-table-column type="selection" width="40px"> </el-table-column>
          <el-table-column prop="userName" label="学员姓名" width="80px">
          </el-table-column
          ><el-table-column prop="mobile" label="手机号" width="120px">
          </el-table-column
          ><el-table-column prop="idCard" label="身份证号" width="180px">
          </el-table-column
          ><el-table-column
            label="性别"
            width="50px"
            :formatter="(row) => (row.sex == 2 ? '男' : '女')"
          >
          </el-table-column
          ><el-table-column prop="email" label="邮箱"> </el-table-column
          ><el-table-column
            prop="certificateName"
            width="160px"
            show-overflow-tooltip
            label="证书名称"
          >
          </el-table-column
          ><el-table-column prop="certificateNum" label="证书编号">
          </el-table-column
          ><el-table-column
            prop="award"
            label="颁发机构"
            width="160px"
            show-overflow-tooltip
          >
          </el-table-column
          ><el-table-column prop="awardTime" label="发证时间" width="100px">
          </el-table-column
          ><el-table-column prop="validity" label="有效期" width="100px">
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="getData"
          @size-change="getData"
          :current-page.sync="searchCondition.pageNumber"
          :page-sizes="[10, 30, 100]"
          :page-size.sync="searchCondition.pageSize"
          :total="searchCondition.total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getPreviousCertificateList } from "@/api/certificate.js";
export default {
  data() {
    return {
      dataList: [],
      searchCondition: {
        pageNumber: 1,
        pageSize: 10,
        search: "",
        createTime: "",
      },
    };
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getPreviousCertificateList(this.searchCondition).then((data) => {
        this.dataList = data.rows;
        this.searchCondition.total = data.total;
        console.log(data);
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .searchBar {
    padding: 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .content {
    margin-top: 15px;
    background: #fff;
    padding: 15px;
    .actBar {
      margin-bottom: 10px;
    }
  }
}
</style>
